// extracted by mini-css-extract-plugin
export default {"container":"ApplicationRequirementItem-module--container--hI-Ev"};